import { extractData } from "../utils";
var hashes = extractData(document.getElementById('hashes-data'));
export function hash(key) {
    return hashes[key];
}
